import {
    GetDeviceNamesByUuidsQuerySchema,
    GetDeviceNamesByUuidsVariablesSchema,
    type GetDeviceNamesByUuidsVariables
} from './changeLog_schemas'
import { useDataFetcher } from '../../utils'

export const useGetDeviceNamesByUuidsQuery = (input: GetDeviceNamesByUuidsVariables) => {
    const variables = GetDeviceNamesByUuidsVariablesSchema.parse(input)
    const result = useDataFetcher('get_device_names_by_uuids', variables, GetDeviceNamesByUuidsQuerySchema, {
        queryKey: ['data_fetcher', 'get_device_names_by_uuids', variables.uuids],
        enabled: variables.uuids.length > 0
    })

    return {
        data: result.data,
        loading: result.isFetching,
        error: result.error,
        refetch: result.refetch
    }
}
